// extracted by mini-css-extract-plugin
var _1 = "Gifting__btn--kSJOh";
var _2 = "Gifting__buttonContainer--eIyIw";
var _3 = "Gifting__cancelBtn--oZ223 Gifting__btn--kSJOh";
var _4 = "Gifting__disclaimerText--IEkmT Gifting__errorMessageVisible--Fu2WZ Gifting__modalText--xmHmU";
var _5 = "Gifting__editButton--OlC4s";
var _6 = "Gifting__errorInputField--GHURN Gifting__inputField--KGU2b Gifting__modalText--xmHmU";
var _7 = "Gifting__errorMessageHidden--VWky6 Gifting__errorMessageVisible--Fu2WZ Gifting__modalText--xmHmU";
var _8 = "Gifting__errorMessageVisible--Fu2WZ Gifting__modalText--xmHmU";
var _9 = "Gifting__fieldContainer--Khk_h";
var _a = "Gifting__fieldName--EPwAG Gifting__modalText--xmHmU";
var _b = "Gifting__horizontalLine--_guuC";
var _c = "Gifting__inputField--KGU2b Gifting__modalText--xmHmU";
var _d = "Gifting__largeInputField--keMBt Gifting__inputField--KGU2b Gifting__modalText--xmHmU";
var _e = "Gifting__modalContainer--Ln4X9";
var _f = "Gifting__modalHeader--dtF8G Gifting__modalText--xmHmU";
var _10 = "Gifting__modalText--xmHmU";
var _11 = "Gifting__recipientFieldName--VR2TU";
var _12 = "Gifting__recipientInfoContainer--DUYyB";
var _13 = "Gifting__saveBtn--oDQvs Gifting__btn--kSJOh";
export { _1 as "btn", _2 as "buttonContainer", _3 as "cancelBtn", _4 as "disclaimerText", _5 as "editButton", _6 as "errorInputField", _7 as "errorMessageHidden", _8 as "errorMessageVisible", _9 as "fieldContainer", _a as "fieldName", _b as "horizontalLine", _c as "inputField", _d as "largeInputField", _e as "modalContainer", _f as "modalHeader", _10 as "modalText", _11 as "recipientFieldName", _12 as "recipientInfoContainer", _13 as "saveBtn" }
